// Physical -> virtual bridge reward toast (see backend `grant_bridge_reward`,
// routers/eden.py): shared by every UI trigger point (PlantCard's single
// water tap, PlantDetailModal's photo check-in, and any future trigger) so
// the reward is announced the same way everywhere rather than each call
// site re-implementing its own copy of this branching.
import { toast } from 'sonner';

const COIN = '\u{1FA99}';

export function showBridgeRewardToast(bridgeReward, t) {
    if (!bridgeReward?.granted) return;
    window.dispatchEvent(new Event('eden:wallet-changed'));
    toast.success(`${COIN} +${bridgeReward.muld_coins} ${t('plant.bridge_coins')}`);
    const bonus = bridgeReward.bonus;
    if (!bonus) return;
    if (bonus.capped) {
        toast(t('plant.bridge_bonus_plot_capped'));
    } else if (bonus.kind === 'seeds') {
        toast.success(`${t('plant.bridge_bonus_seeds')} +${bonus.amount}`);
    } else if (bonus.kind === 'compost') {
        toast.success(`${t('plant.bridge_bonus_compost')} +${bonus.amount}`);
    } else if (bonus.kind === 'plot_slot') {
        toast.success(t('plant.bridge_bonus_plot'));
    }
}
